import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import "./HallOfFame.css";

import alumni1 from "../../utils/images/alumni1.jpeg";
import alumni2 from "../../utils/images/alumni2.jpeg";
import alumni3 from "../../utils/images/alumni3.jpeg";
import alumni4 from "../../utils/images/alumni4.PNG";
import alumni5 from "../../utils/images/alumni5.jpeg";
import alumni6 from "../../utils/images/alumni6.PNG";

const alumniData = [
  {
    name: "Soeb Khan",
    designation: "Practicing Lawyer",
    organization: "Punjab and Haryana High Court & Supreme Court of India",
    image: alumni1,

    tags: ["Lawyer", "LLB", "Batch 2018"],

    description:
      "Soeb Khan, from the School Batch of 2018, is a practicing lawyer associated with the Punjab and Haryana High Court and the Supreme Court of India. He holds both LLB and LLM degrees and is actively engaged in the legal profession.",

    quote:
      "Education and perseverance laid the foundation for my legal career.",
  },

  {
    name: "Dr. Maryam",
    designation: "Junior Resident Doctor",
    organization: "Medical Profession",
    image: alumni2,

    tags: ["Doctor", "MBBS", "Batch 2020"],

    description:
      "Dr. Maryam, a member of the Batch of 2020, completed her MBBS and is currently serving as a Junior Resident Doctor. She is dedicated to patient care and continues to grow in the medical field.",

    quote:
      "Hard work, compassion, and continuous learning are the keys to success in medicine.",
  },

  {
    name: "Mohd Niyamat",
    designation: "Site Engineer",
    organization: "Ericsson",
    image: alumni3,

    tags: ["Engineer", "Btech", "Batch 2008"],

    description:
      "Mohd Niyamat, from Batch 2008 (April 2008), is working as a Site Engineer at Ericsson. Through dedication, technical expertise, and consistent hard work, he has established a successful career in the telecommunications and engineering industry.",

    quote:
      "Success comes from continuous learning, discipline, and dedication to your goals.",
  },
  {
    name: "Sandeep Panchal",
    designation: "Sports Instructor",
    organization: "National Karate Player",
    image: alumni4,

    tags: ["Karate", "National Player", "Batch 2018"],

    description:
      "Sandeep Panchal, from the Batch of 2018, is a National Karate Player and currently serves as a Sports Instructor. Through discipline, dedication, and excellence in sports, he has achieved recognition at the national level and continues to inspire young athletes.",

    quote:
      "Discipline, determination, and hard work are the keys to success in sports and life.",
  },

  {
    name: "Salman Khan",
    designation: "Police Personal",
    organization: "Haryana Police",
    image: alumni5,

    tags: ["Police Personal", "Haryana Police", "Batch 2017"],

    description:
      "Salman Khan, a proud alumnus of the Batch of 2017, is serving in the Haryana Police. His commitment to public service, discipline, and responsibility reflects the values instilled during his educational journey.",

    quote:
      "Serving society with integrity and dedication is the greatest honor.",
  },

  {
    name: "Mohammad Ashfaque Hussain",
    designation: "Cyber Security Engineer",
    organization: "Amazon, Texas, USA",
    image: alumni6,

    tags: ["Engineer", "BE", "Batch 2006"],

    description:
      "Mohammad Ashfaque Hussain, from the Batch of 2006, is currently working in Texas, USA, as a Cyber Security Engineer at Amazon. He contributes to cybersecurity, information security, and digital risk management initiatives, helping safeguard critical systems and technologies.",

    quote:
      "Technology becomes powerful when combined with continuous learning and innovation.",
  },
];

function HallOfFame() {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;

    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % alumniData.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [isPaused]);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % alumniData.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + alumniData.length) % alumniData.length);
  };

  const alumni = alumniData[current];

  return (
    <section className="hall-section">
      <div className="container">
        <div className="text-center mb-2">
          <h3 className="hall-heading">Our Proud Alumni</h3>
          {/* <span className="hall-badge">Hall of Fame</span> */}

          <p className="hall-subtitle">
            Celebrating the achievements of our students who continue to make us
            proud across the world.
          </p>
        </div>

        <div
          className="hall-card"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <button className="hall-arrow left" onClick={prevSlide}>
            ❮
          </button>

          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              className="hall-content"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              {/* LEFT */}
              <div className="hall-tags">
                {alumni.tags.map((tag, index) => (
                  <span key={index} className="tag-pill">
                    {tag}
                  </span>
                ))}
              </div>

              {/* CENTER */}

              <div className="hall-image-wrapper">
                <img
                  src={alumni.image}
                  alt={alumni.name}
                  className="hall-image"
                />
              </div>

              {/* RIGHT */}

              <div className="hall-info">
                <h3>{alumni.name}</h3>

                <h5>{alumni.designation}</h5>

                <p className="organization">{alumni.organization}</p>

                <p className="description">{alumni.description}</p>

                <blockquote>"{alumni.quote}"</blockquote>
              </div>
            </motion.div>
          </AnimatePresence>

          <button className="hall-arrow right" onClick={nextSlide}>
            ❯
          </button>
        </div>

        <div className="hall-dots">
          {alumniData.map((_, index) => (
            <span
              key={index}
              className={current === index ? "dot active" : "dot"}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default HallOfFame;
